import { useEffect, useState } from "react";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface Cargo {
  id: string;
  name: string;
}

interface SelectCargoProps {
  idObra: string;
  value: string; // valor sempre string (pode ser string vazia)
  onChange: (value: string) => void;
}

export function SelectCargo({ idObra, value, onChange }: SelectCargoProps) {
  const [cargos, setCargos] = useState<Cargo[]>([]);

  useEffect(() => {
    if (!idObra) {
      setCargos([]);
      return;
    }
    const fetchData = async () => {
      try {
        const data = await baseApiService.get(`/positions/select/${idObra}`);
        setCargos(data.data.data ?? []);
      } catch (error) {
        console.error("Erro ao carregar cargos:", error);
        setCargos([]);
      }
    };
    fetchData();
  }, [idObra]);

  const selectedValue = typeof value === "string" ? value : "";

  return (
    <SelectField
      label="Selecione um Cargo"
      value={selectedValue}
      onChange={(e) => onChange(e.target.value)}
      required
    >
      <option value="">Selecione...</option>
      {cargos.map((cargo) => (
        <option key={cargo.id} value={cargo.id}>
          {cargo.name.toUpperCase()}
        </option>
      ))}
    </SelectField>
  );
}
